import orderInstance from '../instance'

const fetchAutoConfirmation = () => {
    return orderInstance.get('/auto-confirmation')
}

export default fetchAutoConfirmation


